import { type JsonDataItem } from 'types';

type BaseQueryOption = {
  type?: 'GET' | 'POST' | 'PUT';
  headers?: JsonDataItem;
  body?: JsonDataItem;
};

export const externalQuery = async (url: string, options?: BaseQueryOption) => {
  const response = await fetch(url, {
    method: `${options?.type ?? 'GET'}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...options?.headers,
    },
    body: JSON.stringify(options?.body),
  });

  if (!response.ok) throw await response.json();

  return await response.json();
};
